import { Link } from 'react-router'
import { useCopy, useLocale } from '../content'
import { pathFor } from '../routes'

/**
 * 404. Not in the route table (it has no URL of its own) and never
 * prerendered: an unknown path gets nginx's index.html fallback, main.tsx
 * sees the stamped path differs and client-renders, and the router's `*`
 * route lands here. The locale still follows the URL (`/en/…` → English).
 */
export default function NotFoundPage() {
  const copy = useCopy()
  const locale = useLocale()
  return (
    <main id="main" className="vc2-container py-40 text-center">
      <p className="vc2-kicker">404</p>
      <h1 tabIndex={-1} className="vc2-display mt-4 text-4xl">
        {copy.notFound.title}
      </h1>
      <p className="mx-auto mt-4 max-w-2xl text-vc2-ink-soft">{copy.notFound.text}</p>
      <Link to={pathFor('home', locale)} className="mt-8 inline-block underline underline-offset-4">
        {copy.notFound.backHome}
      </Link>
    </main>
  )
}
